import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from 'components/Typography';
import { withSignupMachineState } from 'domains/signup/signupFlow/context/signupContext';
import { Button } from 'components/Button';
import config from 'config';

const supportEmail = config.get('supportEmail');
const LeadCreationFailed: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Heading level="h2" className="mb-16">
        {t(`signup.direct.steps.leadCreationFailed.title`)}
      </Heading>
      <Paragraph>
        {t(`screener.results.scheduleButton.errorMessage`, {
          supportEmail,
        })}
      </Paragraph>
      <Button as="a" href={`mailto:${supportEmail}`} size="lg" className="sm-d:w-full">
        {t(`support.contactUs`)}
      </Button>
    </>
  );
};
export const SignupErrorDuplicate = withSignupMachineState(LeadCreationFailed, [
  'leadCreationError',
  'consultationError',
]);
